import { render, staticRenderFns } from "./PartBDescription.vue?vue&type=template&id=82244906&lang=pug"
import script from "./PartBDescription.vue?vue&type=script&lang=js"
export * from "./PartBDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports